import { parser } from "../../erd-editor-schema/dist/v3/parser/index.js";
import { toJson } from "../../erd-editor-schema/dist/parser.js";
import { convertToSchema } from "./convert.js";
import { parseDBMLModel } from "./parser.js";
//#region src/utils/schema-dbml-parser/index.ts
var EMPTY_MODEL = {
	tables: [],
	refs: [],
	tableGroups: [],
	enums: {},
	skipped: []
};
function schemaDBMLParserToSchemaJson(dbml, ctx, prepare) {
	const result = parseDBMLModel(dbml);
	const model = result.ok ? result.model : EMPTY_MODEL;
	const schema = parser({});
	const { settings } = prepare ? prepare(schema) : schema;
	const converted = convertToSchema(model, ctx, settings.database);
	converted.settings = settings;
	return toJson(converted);
}
//#endregion
export { schemaDBMLParserToSchemaJson };
